import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TextInput from 'screens/components/basic/TextInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "MonthlyInventoryReport";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: []
        };

    }

    render() {
        const props = this.props;
        let date = new Date();
        return (
            <CardSimple className="p-1">
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-2">
                        <TextInput
                            type="Number"
                            fullWidth={true}
                            name={componentName + LOOKUP.report.MonthlyInventory.year.name}
                            hintText={LOOKUP.report.MonthlyInventory.year.label}
                            label={LOOKUP.report.MonthlyInventory.year.label}
                            floatingLabelText={LOOKUP.report.MonthlyInventory.year.label}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-2">
                        <SelectInput
                            name={componentName + LOOKUP.report.common.month}
                            fullWidth={true}
                            label={LOOKUP.report.common.month}
                            floatingLabelText={LOOKUP.report.common.month}
                            hintText={LOOKUP.report.common.month}
                            options={LOOKUP.report.common.monthOption}
                            defaultValue={date.getMonth().toString()}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-3">
                        <BranchSelectAutoCompleteInput
                            name={componentName + LOOKUP.report.common.branch}
                            fullWidth={true}
                            label={LOOKUP.report.common.branch}
                            floatingLabelText={LOOKUP.report.common.branch}
                            hintText={LOOKUP.report.common.branch}
                            defaultValue={props.loggedBranch.toString()}
                            options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-2">
                        <SelectInput
                            name={componentName + "IsCannabis"}
                            fullWidth={true}
                            defaultValue="2"
                            label={"Type"}
                            floatingLabelText={"Type"}
                            hintText={"Type"}
                            options={props.isCannabisOptions && props.isCannabisOptions.length > 0 ? props.isCannabisOptions : []}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-3">
                        <SelectInput
                            name={componentName + "SelectedCategory"}
                            fullWidth={true}
                            label={"Category"}
                            floatingLabelText={"Category"}
                            hintText={"Category"}
                            defaultValue={"0"}
                            options={(() => {
                                const categoryOptions = props.categories || [];
                                const filteredCategories =
                                    props.isCannabis === 0
                                        ? categoryOptions.filter(x => !x.isCannabis)
                                        : props.isCannabis === 1
                                            ? categoryOptions.filter(x => x.isCannabis)
                                            : categoryOptions;

                                return [{ text: "All", value: "0" }, ...filteredCategories.filter(x => x.value !== "0")];
                            })()}

                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <Button
                            type="IconInButton"
                            className="pull-right mt-2 ml-1 btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.viewReport.name}
                            label={LOOKUP.report.common.viewReport.label}
                            icon={<VisibilityIcon />}
                            onTouchTap={props.showBody}
                        />
                        <Button
                            type="DownloadButton"
                            className="pull-right mt-2 btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.downloadReport.name}
                            label={LOOKUP.report.common.downloadReport.label}
                            onTouchTap={props.download}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        {/* <p className="purpleText"><b>Note: </b></p> */}
                    </div>
                </div>
            </CardSimple>
        )
    }
}

const mapStateToProps = state => {

    return {
        isCannabis: state.form.MonthlyInventoryReportIsCannabis
    };
};

export default connect(mapStateToProps)(Header);

